import * as React from 'react';
import RectImgBox from './BrotherCard';
import './BrotherCard.css';

import Stack from '@mui/material/Stack';

//Rho class
import Aadarsh_Arasu from '../../media/Brothers/Headshots/Rho/Aadarsh_Arasu.jpg';
import Aidan_Chan from '../../media/Brothers/Headshots/Rho/Aidan_Chan.jpeg';
import Alp_Baran_Erkul from '../../media/Brothers/Headshots/Rho/Alp_Baran_Erkul.jpeg';
import Andrew_Subramaniyam from '../../media/Brothers/Headshots/Rho/Andrew_Subramaniyam.jpeg';
import Bridget_Quinn from '../../media/Brothers/Headshots/Rho/Bridget_Quinn.jpg';
import Charlie_Corbett from '../../media/Brothers/Headshots/Rho/Charlie_Corbett.jpg';
import Elaine_Zeng from '../../media/Brothers/Headshots/dummytest.jpeg';
import Heewon_Park from '../../media/Brothers/Headshots/dummytest.jpeg';
import Isabelle_Canty from '../../media/Brothers/Headshots/Rho/Isabelle_Canty.jpeg';
import Jared_Shi from '../../media/Brothers/Headshots/dummytest.jpeg';
import Jason_Redick from '../../media/Brothers/Headshots/dummytest.jpeg';
import Justin_Li from '../../media/Brothers/Headshots/Rho/Justin_Li.jpeg';
import Jonathan_Sim from '../../media/Brothers/Headshots/Rho/Jonathan_Sim.jpeg'
import Leo_Phung from '../../media/Brothers/Headshots/dummytest.jpeg';
import Lillian_Chung from '../../media/Brothers/Headshots/dummytest.jpeg';
import Marissa_Zhai from '../../media/Brothers/Headshots/dummytest.jpeg';
import Nathan_Lee from '../../media/Brothers/Headshots/Rho/Nathan_Lee.jpeg';
import Parth_Prajapati from '../../media/Brothers/Headshots/dummytest.jpeg';
import Winnie_Li from '../../media/Brothers/Headshots/Rho/Winnie_Li.jpg';
import Yena_Yu from '../../media/Brothers/Headshots/Rho/Yena_Yu.JPG';
import Zach_Nordwall from '../../media/Brothers/Headshots/Rho/Zachary_Nordwall.jpeg';


const Rho = () => {
  const rhoClass = [
    {broname: "Aadarsh Arasu", src: Aadarsh_Arasu, alt: "Aadarsh Arasu", majorGrad: "Mechanical Engineering '26"},
    {broname: "Aidan Chan", src: Aidan_Chan, alt: "Aidan Chan", majorGrad: "Biomedical Engineering '24"},
    {broname: "Alp Baran Erkul", src: Alp_Baran_Erkul, alt: "Alp Baran Erkul", majorGrad: "Biomedical Engineering '27"},
    {broname: "Andrew Subramaniyam", src: Andrew_Subramaniyam, alt: "Andrew Subramaniyam", majorGrad: "Mechanical Engineering '26"},
    {broname: "Bridget Quinn", src: Bridget_Quinn, alt: "Bridget Quinn", majorGrad: "Biomedical Engineering '26"},
    {broname: "Charlie Corbett", src: Charlie_Corbett, alt: "Charlie Corbett", majorGrad: "Mechanical Engineering '26"},
    {broname: "Elaine Zeng", src: Elaine_Zeng, alt: "Elaine Zeng", /**majorGrad: "Biomedical Engineering '26"*/},
    {broname: "Heewon Park", src: Heewon_Park, alt: "Heewon Park", /**majorGrad: "Biomedical Engineering '26"*/},
    {broname: "Isabelle Canty", src: Isabelle_Canty, alt: "Isabelle Canty", majorGrad: "Biomedical Engineering '26"},
    {broname: "Jared Shi", src: Jared_Shi, alt: "Jared Shi", /**majorGrad: "Biomedical Engineering '26"*/},
    {broname: "Jason Redick", src: Jason_Redick, alt: "Jason Redick", /**majorGrad: "Biomedical Engineering '26"*/},
    {broname: "Justin Li", src: Justin_Li, alt: "Justin Li", majorGrad: "Biomedical Engineering '25"},
    {broname: "Jonathan Sim", src: Jonathan_Sim, alt: "Jonathan Sim", majorGrad: "Biomedical Engineering '25"},
    {broname: "Leo Phung", src: Leo_Phung, alt: "Leo Phung", /**majorGrad: "Biomedical Engineering '26"*/},
    {broname: "Lillian Chung", src: Lillian_Chung, alt: "Lillian Chung", /**majorGrad: "Biomedical Engineering '26"*/},
    {broname: "Marissa Zhai", src: Marissa_Zhai, alt: "Marissa Zhai", /**majorGrad: "Biomedical Engineering '26"*/},
    {broname: "Nathan Lee", src: Nathan_Lee, alt: "Nathan Lee", majorGrad: "Biomedical Engineering '25"},
    {broname: "Parth Prajapati", src: Parth_Prajapati, alt: "Parth Prajapati", /**majorGrad: "Biomedical Engineering '26"*/},
    {broname: "Winnie Li", src: Winnie_Li, alt: "Winnie Li", majorGrad: "Mechanical Engineering '26"},
    {broname: "Yena Yu", src: Yena_Yu, alt: "Yena Yu", majorGrad: "Computer Engineering '26"},
    {broname: "Zach Nordwall", src: Zach_Nordwall, alt: "Zach Nordwall", majorGrad: "Biomedical Engineering '27"},

  ];
  return (
    <div className = "Classes">
      {rhoClass.map((photo, index) => (
        <RectImgBox
        key = {index}
        broname = {photo.broname}
        src = {photo.src}
        alt = {photo.alt}
        majorGrad = {photo.majorGrad}
        />
      ))}
    </div>
  );
};

export default Rho;